import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { NavLink, useNavigate, useLocation } from "react-router-dom";

import logo from "./assets/img/YTC.png";

const NavBar = ({ onConnectClick }) => {
  const [activeLink, setActiveLink] = useState("home");
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const sections = {
    home: "#home",
    services: "#services",
    technology: "#technology",
    aboutus: "#about-us-section",
  };

  const handleNavItemClick = (value) => {
    setActiveLink(value);
    setExpanded(false);

    const sectionId = sections[value];

    if (!sectionId) return;

    // If not on home page, navigate first
    if (location.pathname !== "/") {
      navigate("/");

      setTimeout(() => {
        const section = document.querySelector(sectionId);

        if (section) {
          section.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 500);
    } else {
      const section = document.querySelector(sectionId);

      if (section) {
        section.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  };

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", onScroll);

    return () =>
      window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1"
        />

        <title>YTC Tech Ventures</title>

        <meta
          name="description"
          content="To empower businesses with innovative, reliable, and scalable technology solutions that drive growth and efficiency."
        />

        <meta
          name="keywords"
          content="Web Development, Application Development, SEO Services, Cloud Services, On-Demand Services"
        />

        <meta
          name="author"
          content="YTC Tech Ventures"
        />

        <meta
          property="og:title"
          content="YTC Tech Ventures - Innovate. Integrate. Inspire."
        />

        <meta
          property="og:description"
          content="Innovate. Integrate. Inspire."
        />

        <meta
          property="og:url"
          content="https://ytctechventures.com"
        />
      </Helmet>

      <Navbar
        expand="md"
        expanded={expanded}
        onToggle={(value) => setExpanded(value)}
        className={`${scrolled ? "scrolled" : ""} ${expanded ? "expanded" : ""
          }`}
      >
        <Container>
          {/* Logo */}
          <Navbar.Brand
            as={NavLink}
            to="/"
          >
            <img
              src={logo}
              alt="YTC Tech Ventures"
              className="navbar-brand"
            />
          </Navbar.Brand>

          {/* Mobile Toggle */}
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>

          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">

              {/* Home */}
              <Nav.Link
                className={
                  activeLink === "home"
                    ? "active navbar-link"
                    : "navbar-link"
                }
                onClick={() =>
                  handleNavItemClick("home")
                }
              >
                Home
              </Nav.Link>

              {/* Services */}
              <Nav.Link
                className={
                  activeLink === "services"
                    ? "active navbar-link"
                    : "navbar-link"
                }
                onClick={() =>
                  handleNavItemClick("services")
                }
              >
                Our Services
              </Nav.Link>

              {/* Technology */}
              <Nav.Link
                className={
                  activeLink === "technology"
                    ? "active navbar-link"
                    : "navbar-link"
                }
                onClick={() =>
                  handleNavItemClick("technology")
                }
              >
                Technology
              </Nav.Link>

              {/* Packages Page */}
              <Nav.Item>
                <NavLink
                  to="/packages"
                  className="navbar-link nav-link"
                  onClick={() => {
                    setExpanded(false);
                    setActiveLink("packages");
                  }}
                >
                  Packages
                </NavLink>
              </Nav.Item>

              {/* About Us */}
              <Nav.Link
                className={
                  activeLink === "aboutus"
                    ? "active navbar-link"
                    : "navbar-link"
                }
                onClick={() =>
                  handleNavItemClick("aboutus")
                }
              >
                About Us
              </Nav.Link>
            </Nav>

            {/* CTA */}
            <span className="navbar-text">
              <button
                className="vvd"
                onClick={() => {
                  setExpanded(false);

                  if (onConnectClick) {
                    onConnectClick();
                  }
                }}
              >
                <span>Let's Connect</span>
              </button>
            </span>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default NavBar;